export default __webpack_public_path__ + "static/media/CloseIcon.4e57886b.svg";